export const rootExec = '-999999';
export const newMenuExec = '0';
export const deleteItemMessage = {entity: 'NETMAIN', key: 1020};
export const deleteFolderMessage = {entity: 'NETMAIN', key: 1021};
